<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @reload="reload"
      @radioChange="radioChange"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],

  components: { PageMain, PageHeader },
  props: {
    custCode: { type: String, default: '' },
    endCustCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentInfoChooseByDraftApi({
          ...form,
          custCode: this.custCode,
          endCustCode: this.endCustCode
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.main.choiceData()
    },
    radioChange(data) {
      this.$emit('radioChange', data)
    },
  },
}
</script>
